import { render, staticRenderFns } from "./BoxItem.vue?vue&type=template&id=6df33541&scoped=true&"
import script from "./BoxItem.vue?vue&type=script&lang=js&"
export * from "./BoxItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxItem.vue?vue&type=style&index=0&id=6df33541&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df33541",
  null
  
)

export default component.exports